import React from 'react';

import { Spinner } from '@zillow/zrs-comet';
import { StyledSpinnerContainer } from './StyledComponents';

const SpinnerContainer = ({ customClass, ...spinnerProps }) => (
    <StyledSpinnerContainer className={`SpinnerContainer ${customClass}`}>
        <Spinner {...spinnerProps} />
    </StyledSpinnerContainer>
);

export default SpinnerContainer;
